import React, {  useEffect } from 'react';
import { useQuery, useMutation } from '@apollo/client';
import { useForm } from 'react-hook-form';
import { View } from 'react-native';
import { ButtonContainer, ButtonGroup, Button  } from '../../elements/buttons';
import Input from '../../elements/inputs';
import { SETTING, UPDATE_SETTING } from '../Settings/queries';

function ManageFeaturedLabel({setShowModal}) {
  const { loading, error, data, refetch } = useQuery(
    SETTING, { variables: {} }
  );

  const [updateSetting] = useMutation(UPDATE_SETTING, {
    onCompleted: () => {
      setShowModal(false);
    }
  });

  const { control, reset, handleSubmit, formState: { errors } } = useForm({
    defaultValues: {
      featuredBlogLabel: ''
    }
  });

  useEffect(() => {
    if(data !== undefined) {
      reset({
        featuredBlogLabel: data.settings.featuredBlogLabel || 'Featured'
      })
    }
  }, [data])

  const onSubmit = (data) => {
    if(data['featuredBlogLabel'] === '' ||
      data['featuredBlogLabel'] === undefined
    ) data['featuredBlogLabel'] = 'Featured'
    updateSetting({ variables: data });
  };

  return (
    <View>
        <View>
          <Input.Text
            label="Featured Blog Label"
            name="featuredBlogLabel"
            control={control}
            errors={errors}
          />
          <ButtonContainer>
            <ButtonGroup>
              <Button label="Submit" onPress={handleSubmit(onSubmit)} />
            </ButtonGroup>
          </ButtonContainer>
        </View>
    </View>
  )
};

export default ManageFeaturedLabel;
